module.exports = __webpack_public_path__ + "static/media/uniswap.7274c784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/uniswap.png
// module id = 134
// module chunks = 0